export const LIKE_SHOWCASE = 'LIKE_SHOWCASE'
export const TOGGLE_SHOWCASE_STATUS = 'TOGGLE_SHOWCASE_STATUS'

export function likeShowcase({
  showcaseId,
  showcaseSlug,
  isStatic = false,
}: {
  showcaseId: string
  showcaseSlug: string
  isStatic?: boolean
}) {
  return {
    type: LIKE_SHOWCASE,
    payload: { showcaseId, showcaseSlug, isStatic },
  }
}

export function toggleShowcaseStatus({
  showcaseId,
  schoolId,
  status,
}: {
  showcaseId: string
  schoolId: string | null
  status: string
}) {
  return {
    type: TOGGLE_SHOWCASE_STATUS,
    payload: { showcaseId, schoolId, status },
  }
}
